import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import bowser from 'bowser';
import remodal from 'remodal';
import '../../../node_modules/jquery-match-height/dist/jquery.matchHeight.js';
import Swiper from 'swiper';

if (bowser.msie === true) {
	$('body').addClass('ie');
} else if (bowser.msedge === true) {
	$('body').addClass('edge');
} else if (bowser.firefox === true) {
	$('body').addClass('ff');
} else if (bowser.tablet === true) {
	$('body').addClass('tablet');
}
if (bowser.mobile === true) {
	$('body').addClass('device--mobile');
	if (bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
} else {
	$('.tel_link').on('click', function() {
		return false;
	});
}

let os,
	ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = 'win10';
} else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = 'win8_1';
} else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = 'win8';
} else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = 'win7';
} else {
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
const gnav = $('.gnav ul').clone();
$('#spnavi')
	.find('#scroller')
	.append(gnav);
let param = {
	target: '#spnavi',
	trigger: '.btn_sp_navi',
	filter: 'resposive_flg',
	speed: 200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop', 100, 400);
totop.exec();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

$('#top_modal_link').on('click', function() {
	if (r.state()() === false) {
		let href = $(this).data('sppage');
		window.location = href;
		return false;
	}
});

/* ===============================================
#	pc アーカイブメニュー
=============================================== */
$('.js-year').on('click', function() {
	$(this)
		.next()
		.slideToggle();
	$(this).toggleClass('active');
});

/* ===============================================
#	sp アーカイブメニュー
=============================================== */
$('.title_side').on('click', function() {
	$(this)
		.next()
		.slideToggle();
	$(this).toggleClass('active');
});

/* ===============================================
#	gnav scrol anim
=============================================== */
var _w = $(window);
const _header = $('#main_header');
var header_anim = function() {
	TweenMax.fromTo(
		_header,
		0.6,
		{ opacity: 0 },
		{ opacity: 1, ease: Power3.easeIn }
	);
};
_w.on('scroll', function() {
	var scrlTop = _w.scrollTop();
	if (r.state()() === true) {
		if (scrlTop > 100) {
			if (!_header.hasClass('fixed')) {
				header_anim();
				$(_header).addClass('fixed');
			}
		} else {
			if (_header.hasClass('fixed')) {
				header_anim();
				$(_header).removeClass('fixed');
			}
		}
	}
});

// /* gmap
// ----------------------- */
let gmap = new Gmap();
$(window).on('load', function() {
	gmap.exec();
});

const text_animation = require('./text_animation');
text_animation();

const imgbox_animation = require('./imgbox_animation');
imgbox_animation();

const mv = require('./mv');
mv();

const home_news = require('./home_news');
home_news();

const form_support = require('./form_support');
form_support();

/* ===============================================
#	tel link
=============================================== */
$(function() {
	var ua = navigator.userAgent;
	if (
		(ua.indexOf('iPhone') > 0 && ua.indexOf('iPod') == -1) ||
		(ua.indexOf('Android') > 0 &&
			ua.indexOf('Mobile') > 0 &&
			ua.indexOf('SC-01C') == -1 &&
			ua.indexOf('A1_07') == -1)
	) {
		$('.tel-link').each(function() {
			var str = $(this).text();
			$(this).html(
				$('<a>')
					.attr('href', 'tel:' + str.replace(/-/g, ''))
					.append(str + '</a>')
			);
		});
	}
});

/* ===============================================
#	matchheight
=============================================== */
$('.js-matchHeight1').matchHeight();
$('.js-matchHeight2').matchHeight();
$('.js-matchHeight3').matchHeight();
$('.js-matchHeight4').matchHeight();
$('.js-matchHeight').matchHeight();



$(function() {
  /* ===============================================
  #	file up load
  =============================================== */
	const fileFormGroup = document.querySelectorAll('.js-fileFormGroup');
	if (fileFormGroup.length > 0) {
		for (const formGroup of fileFormGroup) {
			const form = formGroup.querySelector('.js-fileForm');
			const info = formGroup.querySelector('.js-fileInfo');
			form.addEventListener('change', () => {
				info.textContent = form.files[0].name;
			});
		}
	}

  /* ===============================================
  #	iframe
  =============================================== */
	const wrapElement = (wrapper, element) => {
		element.parentNode.insertBefore(wrapper, element);
		wrapper.appendChild(element);
	};

	// youtube
	const youtubeIframes = document.querySelectorAll(
		'iframe[src*="youtube.com"]'
	);

	for (let i = 0; i < youtubeIframes.length; i++) {
		const youtubeWrapper = document.createElement('div');
		youtubeWrapper.className = 'youtube';
		wrapElement(youtubeWrapper, youtubeIframes[i]);
	}

	// other
	// const iframes = document.querySelectorAll('.js-iframe');

	// for (let i = 0; i < iframes.length; i++) {
	// 	const width = iframes[i].width;
	// 	const height = iframes[i].height;
	// 	const iframeWrapper = document.createElement('div');
	// 	iframeWrapper.style.position = 'relative';

	// 	const heightKeepElement = document.createElement('div');
	// 	heightKeepElement.style.paddingTop = `${height / width * 100}%`;
	// 	iframeWrapper.appendChild(heightKeepElement);

	// 	iframes[i].style.position = 'absolute';
	// 	iframes[i].style.width = '100%';
	// 	iframes[i].style.height = '100%';
	// 	iframes[i].style.top = '0';
	// 	iframes[i].style.left = '0';

	// 	wrapElement(iframeWrapper, iframes[i]);
	// }

	// $('.js-iframe').iFrameResize({ log: true });


  /* ===============================================
  #	studio
  =============================================== */
  const studioSwiper = document.getElementById('js-studioSwiper');
  if (studioSwiper) {
    new Swiper(studioSwiper, {
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 'auto',
      loop: true,
      loopedSlides: 10,
      centeredSlides: true,
      autoplay: 4500,
      speed: 1000,
      spaceBetween: r.state()() ? 0 : 12
    });
  }
});



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js